<div class="container">
    <div class="row">
        <div class="col">
            Catégorie : {{categorie.nom}}
        </div>
        <div class="col">
            Sous Catégorie : {{sousCategorie.nom}}
        </div>
        <div class="col">
            Type de jeu : {{ typeJeu.nom}}
        </div>
    </div>
</div>
